import theme from "@/theme";
import { useMediaQuery as useMuiMediaQuery } from "@mui/material";

export function useMediaQuery() {
  const isLaptop = useMuiMediaQuery(theme.breakpoints.down("xl"));
  const isUltraWide = useMuiMediaQuery(theme.breakpoints.up("xl"));

  return { isLaptop, isUltraWide };
}
